export default __webpack_public_path__ + "static/media/attraceRewardsDistribution.cde00b43.mp4";